module.exports = require('./helpers/bundle-url').getBundleURL('f1UsJ') + "logo-dark.eefe0b7f.svg";